app.controller("Map_CreateOrEditPortletController",
    ['$scope', '$http', '$uibModalInstance', 'createOrEditModalService', 'configurationService', 'data',
        'pluginConfigurationService', 'connectorService', 'editorService', 'kendoGridUtilService', 'mapService', 'dataEvalService', 'Guid', '$timeout', 
        function ($scope, $http, $uibModalInstance, createOrEditModalService, configurationService, data,
            pluginConfigurationService, connectorService, editorService, kendoGridUtilService, mapService, dataEvalService, Guid, $timeout) {

            $scope.model = createOrEditModalService.getModel("Map", data);
            $scope.configurationModel = pluginConfigurationService.getConfigurationModel($scope.model.Configuration, "Map");

            if (!$scope.configurationModel.ColorRulesConfiguration.DefaultColor) {
                $scope.configurationModel.ColorRulesConfiguration.DefaultColor = "rgb(92, 186, 230)";
            }

            if (!$scope.configurationModel.IconsConfiguration.DefaultIcon) {
                $scope.configurationModel.IconsConfiguration.DefaultIcon = "user";
            }

            $scope.connectorService = connectorService;
            $scope.editorService = editorService;

            $scope.panelBarOptions = {
                expandMode: "single",
                select: $scope.expandCollapse
            };

            /*pluginConfigurationService.assignPositions($scope.configurationModel.ColorRulesConfiguration.ColorRules);
            pluginConfigurationService.assignPositions($scope.configurationModel.IconsConfiguration.Icons);
            pluginConfigurationService.assignPositions($scope.configurationModel.FlowConfiguration.CustomFlows);
            pluginConfigurationService.assignPositions($scope.configurationModel.TooltipConfiguration.Fields);
            */
            $scope.createWorkflowTypes = [{
                    "type": "dsWithPagingAndFiltering",
                    "displayName": "Data Source with paging and filtering"
                }, {
                    "type": "datasource",
                    "displayName": "Data Source"
                }
            ];

            $scope.validateDataSource = function () {

                if (!$scope.configurationModel.MarkersDatasource.LatitudeColumnName || $scope.configurationModel.MarkersDatasource.LatitudeColumnName == '') {
                    return false;
                }
                if (!$scope.configurationModel.MarkersDatasource.LongitudeColumnName || $scope.configurationModel.MarkersDatasource.LongitudeColumnName == '') {
                    return false;
                }
                return true;
            };

            $scope.colorPickerOptions = function() {
                return {
                    columns: 12,
                    tileSize: {
                        width: 34,
                        height: 34
                    },
                    palette: $.VisualPlanningColorList
                };
            };

            //2'nd
            $scope.colorRulesGridOptions = {
                editable: true,
                scrollable: false,
                toolbar: [{ name: "create", text: "Add" }],
                columns: [
                    {
                        field: "Position",
                        title: "Pos",
                        width: 24,
                        readonly: true,
                        editor: kendoGridUtilService.getDummyEditor('<div class="position glyphicon glyphicon-align-justify">&nbsp;</div>'),
                        template:
                            '<div id="ruleId_#: Position #" kendo-droptarget k-drop="onRuleDrop" kendo-draggable k-hint="draggableHint" data-uid="#: uid #" class="position glyphicon glyphicon-align-justify">&nbsp;</div>'
                    },
                    {
                        field: "Colour",
                        title: "Colour",
                        width: "100px",
                        editor: kendoGridUtilService.getColorPickerFromPalette(),
                        template: kendoGridUtilService.getColorTemplate("Colour")
                    },
                    {
                        field: "FirstValue",
                        title: "First Value",
                        width: "80px"
                    },
                    {
                        field: "Func",
                        title: "Func",
                        width: "80px",
                        editor: kendoGridUtilService.makeKendoComboBoxFromList(dataEvalService.Functions, 'Name', 'Id'),
                        template: kendoGridUtilService.getListTemplate(dataEvalService.Functions, 'Name', 'Id', 'Func')
                    },
                    { field: "SecondValue", title: "Second Value", width: "100px" },
                    {
                        command: [
                            {
                                name: "destroy",
                                template: "<div class='k-button k-button-icontext k-grid-delete gridButton'><span class='k-icon k-i-close'></span></div>"
                            }
                        ],
                        width: 24
                    }
                ],
                dataSource: new kendo.data.DataSource({
                    data: $scope.configurationModel.ColorRulesConfiguration.ColorRules,
                    autoSync: true,
                    transport: {
                        read: function (o) {
                            o.success($scope.configurationModel.ColorRulesConfiguration.ColorRules);
                        },
                        create: function (o) {
                            var item = o.data;
                            item.Position = $scope.configurationModel.ColorRulesConfiguration.ColorRules.length + 1;
                            $scope.configurationModel.ColorRulesConfiguration.ColorRules.unshift(item);
                            o.success(item);
                        },
                        update: function (o) {
                            o.success();
                        },
                        destroy: function (o) {
                            for (var index = 0; index < $scope.configurationModel.ColorRulesConfiguration.ColorRules.length; index++) {
                                if ($scope.configurationModel.ColorRulesConfiguration.ColorRules[index].Position === o.data.Position) {
                                    $scope.configurationModel.ColorRulesConfiguration.ColorRules.splice(index, 1);
                                    break;
                                }
                            }
                            o.success();
                        }
                    },
                    schema: {
                        model: {
                            id: "Position",
                            fields: {
                                Position: { type: "int", defaultValue: 0 },
                                ItemType: { type: "string" },
                                FirstValue: { type: "string" },
                                Func: { type: "string", defaultValue: 1 },
                                SecondValue: { type: "string" },
                                Colour: {
                                    type: "string",
                                    defaultValue: "#5cbae6", //#CBC5A7
                                    validation: {
                                        required: { message: "Field is required"}  }
                                }
                            }
                        }
                    }
                })
            };
            
            //this is requied if we need add to the end of the list - can't be moved easy inside datasource
            $scope.colorRulesGridOptions.dataSource.fetch(function () {
                $scope.colorRulesGridOptions.dataSource.sort({ field: "Position", dir: "asc" });
            });

            //Make combobox for second column. It's a hack bt, copied.
            editorService.createColumnNameComboBox($scope.colorRulesGridOptions.columns[2], $scope.model);

			$scope.overlaysColorRulesGridOptions = {
				editable: true,
				scrollable: false,
				toolbar: [{ name: "create", text: "Add" }],
				columns: [
					{
						field: "Position",
						title: "Pos",
						width: 24,
						readonly: true,
						editor: kendoGridUtilService.getDummyEditor('<div class="position glyphicon glyphicon-align-justify">&nbsp;</div>'),
						template:
							'<div id="ruleId_#: Position #" kendo-droptarget k-drop="onRuleDrop" kendo-draggable k-hint="draggableHint" data-uid="#: uid #" class="position glyphicon glyphicon-align-justify">&nbsp;</div>'
					},
					{
						field: "Colour",
						title: "Colour",
						width: "100px",
						editor: kendoGridUtilService.getColorPickerFromPalette(),
						template: kendoGridUtilService.getColorTemplate()
					},
					{
						field: "FillColor",
						title: "Fill colour",
						width: "100px",
						editor: kendoGridUtilService.getColorPickerFromPalette(),
						template: kendoGridUtilService.getColorTemplate('FillColor')
					},
					{
						field: "FirstValue",
						title: "First Value",
						width: "100px"
					},
					{
						field: "Func",
						title: "Func",
						width: "100px",
						editor: kendoGridUtilService.makeKendoComboBoxFromList(dataEvalService.Functions, 'Name', 'Id'),
						template: kendoGridUtilService.getListTemplate(dataEvalService.Functions, 'Name', 'Id', 'Func')
					},
					{ field: "SecondValue", title: "Second Value", width: "100px" },
					{
						command: [
							{
								name: "destroy",
								template: "<div class='k-button k-button-icontext k-grid-delete gridButton'><span class='k-icon k-i-close'></span></div>"
							}
						],
						width: 24
					}
				],
				dataSource: new kendo.data.DataSource({
					data: $scope.configurationModel.OverlaysColorRulesConfiguration.ColorRules,
					autoSync: true,
					transport: {
						read: function (o) {
							o.success($scope.configurationModel.OverlaysColorRulesConfiguration.ColorRules);
						},
						create: function (o) {
							var item = o.data;
							item.Position = $scope.configurationModel.OverlaysColorRulesConfiguration.ColorRules.length + 1;
							$scope.configurationModel.OverlaysColorRulesConfiguration.ColorRules.unshift(item);
							o.success(item);
						},
						update: function (o) {
							o.success();
						},
						destroy: function (o) {
							for (var index = 0; index < $scope.configurationModel.OverlaysColorRulesConfiguration.ColorRules.length; index++) {
								if ($scope.configurationModel.OverlaysColorRulesConfiguration.ColorRules[index].Position === o.data.Position) {
									$scope.configurationModel.OverlaysColorRulesConfiguration.ColorRules.splice(index, 1);
									break;
								}
							}
							o.success();
						}
					},
					schema: {
						model: {
							id: "Position",
							fields: {
								Position: { type: "int", defaultValue: 0 },
								FirstValue: { type: "string" },
								Func: { type: "string", defaultValue: 1 },
								SecondValue: { type: "string" },
								Colour: {
									type: "string",
									defaultValue: "#5cbae6",
                                    validation: {
                                        required: { message: "Field is required"}  }
								},
								FillColor: {
									type: "string",
									defaultValue: "#5cbae6",
                                    validation: {
                                        required: { message: "Field is required"}  }
								}

							}
						}
					}
				})
			};
			editorService.createColumnNameComboBox($scope.overlaysColorRulesGridOptions.columns[3], $scope.model, $scope.configurationModel.FlowConfiguration.OverlaysDataSource);

	        $scope.overlaysColorRulesGridOptions.dataSource.fetch(function () {
		        $scope.overlaysColorRulesGridOptions.dataSource.sort({ field: "Position", dir: "asc" });
	        });
			
            $scope.flowOptions = {  
                editable: "inline",
                scrollable: false,
                edit: function (e) {
                    var commandCell = e.container.find("td:last");
                    commandCell.html(
                        "<a class='k-button k-button-icontext k-grid-update gridButton'><span class='k-icon k-i-checkmark'></span></a>" +
                        "<a class='k-button k-grid-cancel gridButton'><span class='k-icon k-i-cancel'></span></a>"
                        );
                },
                toolbar: [{ name: "create", text: "Add" }],
                columns: [
                    { field: "DisplayName", title: "Display Name", width: "150px" },
                    {
                        field: "CustomFlow",
                        title: "Custom Flow",
                        width: "200px",
                        editor: kendoGridUtilService.makeWorkflowTree("workflows", "Name", "Id"),
                        template: '<span ng-bind="dataItem.CustomFlow.Name"></span>'
                    },
                    {
                        field: "AlwaysEnabled",
                        title: "Always Enabled",
                        width: "70px",
                        template: "<input type='checkbox' #= AlwaysEnabled ? checked='checked' : '' # ></input>",
                        editor: kendoGridUtilService.makeKendoCheckboxFromValue("AlwaysEnabled"),

                    },
                    { field: "LeftValue", title: "Left Value", width: "150px" },
                    {
                        field: "Func",
                        title: "Func",
                        width: "100px",
                        editor: kendoGridUtilService.makeKendoComboBoxFromList(dataEvalService.Functions, 'Name', 'Id'),
                        template: kendoGridUtilService.getListTemplate(dataEvalService.Functions, 'Name', 'Id', 'Func')
                    },
                    { field: "RightValue", title: "Right Value", width: "150px" },
                    {
                        command: [
                            {
                                name: "edit",
                                template: "<a class='k-button k-button-icontext k-grid-edit gridButton'><span class='k-icon k-i-edit'></span></a>"
                            },
                            {
                                name: "destroy",
                                template: "<div class='k-button k-button-icontext k-grid-delete gridButton'><span class='k-icon k-i-close'></span></div>"
                            }
                        ],
                        width: 24
                    }],

                dataSource: new kendo.data.DataSource({
                    data: $scope.configurationModel.FlowConfiguration.CustomFlows,
                    autoSync: false,
                    transport: {
                        read: function (o) {
                            if ($scope.configurationModel.FlowConfiguration.CustomFlows) {
                                o.success($scope.configurationModel.FlowConfiguration.CustomFlows);
                            } else {
                                o.success([]);
                                $scope.configurationModel.FlowConfiguration.CustomFlows = [];
                            }
                        },
                        create: function (o) {
                            var item = o.data;
                            item.Position = $scope.configurationModel.FlowConfiguration.CustomFlows + 1;
                            item.Code = Guid.newGuid();
                            $scope.configurationModel.FlowConfiguration.CustomFlows.unshift(item);
                            o.success(item);
                        },
                        update: function (o) {
                            o.success();
                        },
                        destroy: function (o) {
                            for (var index = 0;
                                index < $scope.configurationModel.FlowConfiguration.CustomFlows.length;
                                index++) {
                                if ($scope.configurationModel.FlowConfiguration.CustomFlows[index].Position == o.data.Position) {
                                    $scope.configurationModel.FlowConfiguration.CustomFlows.splice(index, 1);
                                    break;
                                }
                            }
                            o.success();
                        },
                    },
                    schema: {
                        model: {
                            id: "Position",
                            fields: {
                                DisplayName: {
                                    type: "string",
                                    validation: {
                                        required: { message: "Field is required"} }
                                },
                                CustomFlow: {
                                    validation: {
                                        required: true
                                    }
                                },
                                AlwaysEnabled: { type: "boolean" },
                                LeftValue: { type: "string" },
                                Func: { type: "string", defaultValue: "1" },
                                RightValue: { type: "string" }
                            }
                        }
                    }
                })
            };

            editorService.createNotMandatoryColumnNameComboBox($scope.flowOptions.columns[3], $scope.model);
			
            $scope.iconGrid = {
                editable: true,
                scrollable: false,
                toolbar: [{ name: "create", text: "Add" }],
                columns: [
                    {
                        field: "Position",
                        title: "Pos",
                        width: 24,
                        readonly: true,
                        editor: kendoGridUtilService.getDummyEditor(
                            '<div class="position glyphicon glyphicon-align-justify">&nbsp;</div>'),
                        template:
                            '<div id="iconId_#: Position #" kendo-droptarget k-drop="onIconDrop" kendo-draggable k-hint="draggableHint" data-uid="#: uid #" class="position glyphicon glyphicon-align-justify">&nbsp;</div>'
                    },
                    { field: "Icon", title: "Icon", width: "50px" },
                    { field: "FirstValue", title: "First Value", width: "150px" },
                    {
                        field: "Func",
                        title: "Func",
                        width: "100px",
                        editor: kendoGridUtilService.makeKendoComboBoxFromList(dataEvalService.Functions, 'Name', 'Id'),
                        template: kendoGridUtilService.getListTemplate(dataEvalService.Functions, 'Name', 'Id', 'Func')
                    },
                    { field: "SecondValue", title: "Second Value", width: "150px" },
                    {
                        field: "ShowOnLegend",
                        title: "Show in Legend",
                        width: "50px",
                        editor: kendoGridUtilService.makeKendoCheckboxFromValue("ShowOnLegend"),
                        template: '<span>#= ShowOnLegend ? "Yes" : "No" #</span>'
                    },
                    {
                        command: [
                            {
                                name: "destroy",
                                template: "<div class='k-button k-button-icontext k-grid-delete gridButton'><span class='k-icon k-i-close'></span></div>"
                            }
                        ], width: 24
                    }
                ],
                dataSource: new kendo.data.DataSource({
                    data: $scope.configurationModel.IconsConfiguration.Icons,
                    autoSync: true,
                    transport: {
                        read: function (o) {
                            o.success($scope.configurationModel.IconsConfiguration.Icons);
                        },
                        create: function (o) {
                            var item = o.data;
                            item.Position = $scope.configurationModel.IconsConfiguration.Icons.length + 1;
                            $scope.configurationModel.IconsConfiguration.Icons.unshift(item);
                            o.success(item);
                        },
                        update: function (o) {
                            o.success();
                        },
                        destroy: function (o) {
                            for (var index = 0; index < $scope.configurationModel.IconsConfiguration.Icons.length; index++) {
                                if ($scope.configurationModel.IconsConfiguration.Icons[index].Position === o.data.Position) {
                                    $scope.configurationModel.IconsConfiguration.Icons.splice(index, 1);
                                    break;
                                }
                            }
                            o.success();
                        }
                    },
                    schema: {
                        model: {
                            id: "Position",
                            fields: {
                                Position: { type: "int", defaultValue: 0 },
                                FirstValue: { type: "string" },
                                Func: { type: "string", defaultValue: 1 },
                                SecondValue: { type: "string" },
                                Icon: { type: "string" },
                                ShowOnLegend: {
                                    type: "boolean",
                                    defaultValue: false,
                                    validation: { required: false }
                                }
                            }
                        }
                    }
                })
            };
            editorService.createColumnNameComboBox($scope.iconGrid.columns[2], $scope.model);

            $scope.iconGrid.dataSource.fetch(function () {
                $scope.iconGrid.dataSource.sort({ field: "Position", dir: "asc" });
            });

            $scope.tooltipGridOptions = {
                editable: true,
                scrollable: false,
                toolbar: [
                    {
                        name: "create", text: "Add"
                    }
                ],
                columns: [
                    { field: "DatabaseColumn", title: "Datasource column", width: "400px" },
                    { field: "Editor", title: "Editor", width: "400px", editor: editorService.createBasicEditorDropDownList },
                    {
                        command: [
                            {
                                name: "destroy",
                                template: "<div class='k-button k-button-icontext k-grid-delete gridButton'><span class='k-icon k-i-close'></span></div>"
                            }
                        ],
                        width: 6
                    }
                ],

                dataSource: new kendo.data.DataSource({
                    autoSync: true,
                    transport: {
                        read: function (o) {
                            if (!$scope.configurationModel.TooltipConfiguration.Fields) {
                                $scope.configurationModel.TooltipConfiguration.Fields = [];
                            }
                            o.success($scope.configurationModel.TooltipConfiguration.Fields);
                        },
                        create: function (o) {
                            var item = o.data;
                            item.Position = $scope.configurationModel.TooltipConfiguration.Fields.length + 1;
                            $scope.configurationModel.TooltipConfiguration.Fields.unshift(item);
                            o.success(item);
                        },
                        update: function (o) {
                            o.success();
                        },
                        destroy: function (o) {
                            for (var index = 0; index < $scope.configurationModel.TooltipConfiguration.Fields.length; index++) {
                                if ($scope.configurationModel.TooltipConfiguration.Fields[index].Position === o.data.Position) {
                                    $scope.configurationModel.TooltipConfiguration.Fields.splice(index, 1);
                                    break;
                                }
                            }
                            o.success();
                        }
                    },
                    schema: {
                        model: {
                            id: "Position",
                            fields: {
                                DatabaseColumn: { type: "string" },
                                Editor: { defaultValue: "Text" }
                            }
                        }
                    }
                })
            };
            editorService.createColumnNameComboBox($scope.tooltipGridOptions.columns[0], $scope.model);


            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            /**
             * Assign to transatable objects codes if not assigned yet
             * @returns {} 
             */
            function assignTranslationCodes() {

                if ($scope.configurationModel.TooltipConfiguration != null) {
                    if (!$scope.configurationModel.TooltipConfiguration.Code) {
                        $scope.configurationModel.TooltipConfiguration.Code = Guid.newGuid();
                    }
                    if (Guid.isEmpty($scope.configurationModel.TooltipConfiguration.Code)) {
                        $scope.configurationModel.TooltipConfiguration.Code = Guid.newGuid();
                    }
                }
            }

            $scope.deleteProperty = function() {
                $scope.portletConfigurationForm.createWorkflowForm = null;
                return true;
            };

            $scope.ok = function () {
                
                /* Translation codes */
                assignTranslationCodes();

                //need stay here, as portletContainerLayouts using this.
                configurationService.saveProperties($scope.model.Properties, $scope.configurationModel);

                $scope.model.Configuration = JSON.stringify($scope.configurationModel);

                $uibModalInstance.close($scope.model);
            };

        }
    ]);